import { createTaskFilterFunction, RunbookFilterType } from './filters'
import { TaskListTask } from 'main/services/queries/types'

export const hasComments = createTaskFilterFunction('c', (task: TaskListTask, filters: RunbookFilterType): boolean => {
  return filters.c ? task.comments_count > 0 : task.comments_count === 0
})
